import { ResponseData } from "./types";
import { httpClient } from "./common";
import { withApiErrorHandling } from "../APIs/withApiErrorHandling";

export class NotificationsAPI {
  private static readonly API_URL = "/notifications";

  static async sendCompetitionStartReminder(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(`${this.API_URL}/start-reminder`, undefined, true),
      "Error al enviar el recordatorio"
    );
  }

  static async toggleScheduledNotifications(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(`${this.API_URL}/scheduled/toggle`, undefined, true),
      "Error al cambiar el estado de las notificaciones programadas"
    );
  }

  static async getScheduledNotificationsStatus(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(`${this.API_URL}/scheduled/status`, true),
      "Error al obtener el estado de las notificaciones programadas"
    );
  }

  static async getLastCompetitionStartReminder(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(`${this.API_URL}/last-competition-start-reminder`, true),
      "Error al obtener el recordatorio enviado por última vez"
    );
  }
}
